export default defineNuxtPlugin((nuxtApp) => {
    const { sessionSiteLocale } = useSessionSiteLocale();
    // // called right after a new locale has been set
    nuxtApp.hook('i18n:localeSwitched', ({ newLocale }) => {
        // this saves the i18n plugin locale state into Pinia/Session storage
        sessionSiteLocale.value = newLocale;
    });
});
